import "./styles.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import CountrySelect from "../CountrySelect";
import { useLang } from "../../context/langProvider";
import logo from "../../assets/logo.png";
import { fetchActivities } from '../../redux/actions/activityActions';
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

const HeroSection = () => {
    const { t,lang } = useLang();
    const { mainActivities = []} = useSelector((state) => state.activity || {});

    const [parentId, setParentId] = useState("");
    const [activityId, setActivityId] = useState("");
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(fetchActivities(lang));
    }, [dispatch, lang]);

    const selectedActivity = mainActivities.find(
        (activity) => String(activity.id) === String(parentId)
    );

    const selectedSubActivity = selectedActivity?.sousCategories?.find(
        (sub) => String(sub.id) === String(activityId)
    );
    return (
        <section className="heroSection background-primary">
            <img className="hero-logo" src={logo} alt="logo" />
            <h1>{t("hero-title")}</h1>
            <h2>{t("hero-subtitle")}</h2>
            <div className="containerHeroSection">
                <div className="containerAppelOffres">
                    <h2>{t("title-appel-offres")}</h2>
                    <button>{t("btn-appel-offres")}</button>
                </div>
                <div className="separator"></div>
                <div className="containerAdvancedSearch">
                    <h2>{t("hero-title-advanced-search")}</h2>
                    <h3>{t("hero-advanced-search")}</h3>
                    <form>
                        <p>{t("country-search")}</p>
                        <div className="countrySearch">
                            <CountrySelect />
                        </div>
                        <div>
                            <label htmlFor="mainActivity">Activité principale</label><br />
                                <select
                                    id="mainActivity"
                                    value={parentId}
                                    onChange={(e) => {
                                    setParentId(e.target.value);
                                    setActivityId(""); // Réinitialiser la sous-activité
                                    }}
                                >
                                    <option value="">-- Sélectionner --</option>
                                    {mainActivities.map((activity) => (
                                    <option key={activity.id} value={activity.id}>
                                        {activity.name}
                                    </option>
                                    ))}
                                </select>
                        </div>
                        {
                        selectedActivity?.sousCategories?.length > 0 && (
                        <div>
                            <label htmlFor="subActivity">Sous-activité</label><br />
                            <select
                            id="subActivity"
                            value={activityId}
                            onChange={(e) => setActivityId(e.target.value)}
                            >
                            <option value="">-- Sélectionner --</option>
                            {selectedActivity.sousCategories.map((sub) => (
                                <option key={sub.id} value={sub.id}>
                                {sub.name}
                                </option>
                            ))}
                            </select>
                        </div>
                        )}

                        <p>{t("distance")}</p>
                        <div className="distance-filter">
                            <label>
                                <input type="radio" name="distance" value="10000000" />
                                {t("illimitee")}
                            </label>
                            <label>
                                <input type="radio" name="distance" value="5" />
                                {"< 5km"}
                            </label>
                            <label>
                                <input type="radio" name="distance" value="25" />
                                {"< 25km"}
                            </label>
                            <label>
                                <input type="radio" name="distance" value="50" />
                                {"< 50km"}
                            </label>
                        </div>
                        <div className="input-form">
                            <label htmlFor="keyword">{t("keyword")}</label>
                            <input type="text" name="keyword" id="keyword" placeholder={t("set-keyword")} />
                        </div>
                        <div className="input-form">
                            <button type="submit">
                                <FontAwesomeIcon icon={faMagnifyingGlass} /> {t("search-button")}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </section>
    );
};

export default HeroSection;
